import { ref } from "vue"

export const messageErrorSelectOptionHappyEmpty = {
    message: '',
    type: ''
}

export const messageErrorSelectOptionHappy = ref<typeof messageErrorSelectOptionHappyEmpty[]>([])